<template>
  <div class="sh" :class="{ 'sh--spaced': spaced }" data-test="settings-section-head">
    <div class="sh__main">
      <div class="sh__row">
        <span class="sh__title">{{ title }}</span>
        <span v-if="count !== null" class="sh__count" data-test="settings-section-count">{{ count }}</span>
      </div>
      <div v-if="description" class="sh__desc">{{ description }}</div>
    </div>
    <button
      v-if="actionLabel"
      type="button"
      class="sh__action"
      data-test="settings-section-action"
      @click="$emit('action')"
    >{{ actionLabel }}</button>
  </div>
</template>

<script>
/**
 * A section heading between cards: the title, an optional count pill, one line of description, and an
 * optional link-style action on the right ("Expand all" / "Collapse all").
 *
 * Presentational. ⛔ No prop named patNum / siteID / loading / allSettings / isSuperAdmin / userID.
 */
export default {
  name: 'SectionHead',
  props: {
    title: { type: String, required: true },
    count: { type: Number, default: null },
    description: { type: String, default: '' },
    actionLabel: { type: String, default: '' },
    /** Extra room above (a heading that follows a card). */
    spaced: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../workflow-tokens';

.sh {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 0 2px;

  &--spaced { margin-top: 8px; }
}

.sh__main { flex: 1 1 auto; min-width: 0; }

.sh__row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sh__title {
  font-family: $fu-font-display;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: $fu-text;
}

.sh__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 20px;
  background: $fu-neutral-100;
  color: $fu-neutral-600;
  font-size: 11.5px;
  font-weight: 700;
}

.sh__desc {
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.45;
  color: $fu-neutral-500;
}

.sh__action {
  @include fu-link-btn;
  flex: none;
  padding: 0 0 1px;
  font-size: 13px;
  font-weight: 700;

  @include wf-touch { min-height: 44px; align-items: center; }
}
</style>
